export default __webpack_public_path__ + "static/media/1887.79e54807.png";